<div class="container">
  <mat-spinner *ngIf="!init" color="primary" diameter="48"></mat-spinner>
  <div class="jobs-container">
    <ng-container *ngIf="tabManager != null">
      <div
        *ngFor="let tab of tabManager.tabs"
        class="job clickable"
        [ngClass]="tab === tabManager.activeTab ? 'active-tab' : 'inactive-tab'"
        (click)="openTab(tab)"
      >
        <span class="strong">{{ tab.title }}{{ tab.oldPlatformIdTitle }}</span>
        <span *ngIf="tab.subProjectExecutedForClient">
          <mat-icon
            class="small-medium-icon translate-check"
            svgIcon="check"
          ></mat-icon>
        </span>
      </div>
    </ng-container>
  </div>
  <div #projectDetailTabContent></div>
</div>
<div *ngIf="init" class="container d-flex justify-content-end">
  <button
    *ngIf="forAtelier"
    class="btn btn-close"
    mat-flat-button
    (click)="closeTab()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
